import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { sizeChangeShowTable } from './actions'

function mapStateToProps(state, hocProps) {
    const module = _.get(hocProps, 'module', null)
    const block = _.get(hocProps, 'block', null)
    const id = _.get(hocProps, 'id', null)

    if (!module || !block || !id) return state

    return {
        showProfitTable: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'showProfitTable']),
        showCapitalTable: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            block,
            'customData',
            'showCapitalTable',
        ]),
        showTurnoverTable: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            block,
            'customData',
            'showTurnoverTable',
        ]),
        showEmployeeTable: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            block,
            'customData',
            'showEmployeeTable',
        ]),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            sizeChangeShowTable,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
